import React from "react";

function GreaterThanSvgBlog() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="12"
      fill="none"
      viewBox="0 0 7 12"
    >
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 1.333L5.667 6 1 10.667"
      ></path>
    </svg>
  );
}

export default GreaterThanSvgBlog;
